import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixBroadcastIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <g clipPath="url(#skuflixBroadcastClip)">
        <path
          d="M18.3787 18.3753C19.6401 17.1139 20.4991 15.5068 20.8471 13.7572C21.1951 12.0076 21.0165 10.1941 20.3339 8.54602C19.6512 6.89793 18.4951 5.48929 17.0119 4.49822C15.5287 3.50715 13.7849 2.97817 12.001 2.97817C10.2171 2.97817 8.47328 3.50715 6.99004 4.49822C5.5068 5.48929 4.35076 6.89793 3.6681 8.54602C2.98544 10.1941 2.80683 12.0076 3.15484 13.7572C3.50286 15.5068 4.36188 17.1139 5.62327 18.3753"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M16.0684 16.0617C16.8729 15.2573 17.4208 14.2323 17.6427 13.1165C17.8647 12.0007 17.7507 10.8441 17.3154 9.793C16.88 8.74191 16.1427 7.84353 15.1968 7.21147C14.2508 6.5794 13.1387 6.24204 12.001 6.24204C10.8633 6.24204 9.75115 6.5794 8.8052 7.21147C7.85924 7.84353 7.12196 8.74191 6.68659 9.793C6.25121 10.8441 6.1373 12.0007 6.35925 13.1165C6.5812 14.2323 7.12905 15.2573 7.93352 16.0617"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M12.0009 14.6113C13.4447 14.6113 14.6152 13.4408 14.6152 11.997C14.6152 10.5532 13.4447 9.38281 12.0009 9.38281C10.5571 9.38281 9.38672 10.5532 9.38672 11.997C9.38672 13.4408 10.5571 14.6113 12.0009 14.6113ZM12.0009 14.6113V21.1123"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="skuflixBroadcastClip">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
